module.exports = __webpack_public_path__ + "img/icon_RANDOM.a346a645.png";